export class CountryEnumDataModel {
  Id: number;
  JurisdictionId: number;
  IsoCode: string;
  Name: string;
  CurrencyIsoCode: string;
}
